import { ApiCompetition } from "../../../types";
import { Select, SelectOption } from "../../../components/forms";

type Props = { competition?: ApiCompetition; canChangeCategory?: boolean };

const CategorySelect = ({ canChangeCategory, competition }: Props) => (
  <Select disabled={!canChangeCategory}>
    <SelectOption value="" disabled defaultValue="" hidden>
      Choose a category...
    </SelectOption>
    {competition?.stages[0]?.categories?.map((category) => (
      <SelectOption value={category.uuid} key={category.uuid}>
        {category.name}
      </SelectOption>
    ))}
  </Select>
);

export default CategorySelect;
